import {
  UnauthenticatedTemplate,
  AuthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { HorizontalHeader } from "@EMOrg-prd/react-standard";
import { loginRequest } from "../modules/Auth";
import { useEffect } from "react";
import { InteractionStatus } from "@azure/msal-browser";

const Header = () => {
  const { instance, accounts, inProgress } = useMsal();

  const handleLogin = async () => await instance.loginRedirect(loginRequest);
  const handleLogout = async () => await instance.logout();

  useEffect(() => {
    (async () => {
      if (inProgress === InteractionStatus.None && !accounts[0]) {
        await instance.loginRedirect(loginRequest);
      }
    })();
  }, [accounts, instance, inProgress]);

  return (
    <HorizontalHeader
      title={
        <>
          AuthPortal{" "}
          <span style={{ fontFamily: "EMPrintLight" }}>
            | Enabling Services
          </span>
        </>
      }
      variant="condensed"
      color="main"
    >
      <HorizontalHeader.Nav>
        <UnauthenticatedTemplate>
          <HorizontalHeader.Nav.Item
            onClick={async () => {
              await handleLogin();
            }}
          >
            Login
          </HorizontalHeader.Nav.Item>
        </UnauthenticatedTemplate>
        <AuthenticatedTemplate>
          <HorizontalHeader.Nav.Item
            onClick={async () => {
              await handleLogout();
            }}
          >
            <b>
              {accounts[0]?.name ?? accounts[0]?.username ?? "Unauthenticated"}
            </b>
             | Logout
          </HorizontalHeader.Nav.Item>
        </AuthenticatedTemplate>
      </HorizontalHeader.Nav>
    </HorizontalHeader>
  );
};

export default Header;
